import { urlApi, databaseApi, apiInterface } from './interface'
import { prepareDatabaseV1 } from './DevDatabase'
import API from './api';

export interface Config {
    API: API,
    recaptchaToken: any,
}

function getConfig(location: string): Config {
    if(location === "http://localhost:8004") {
        
        return {
            API: new API(new urlApi(location + "/api/v1")),
            recaptchaToken: 'xxxxx', //update token!
        }
        /*return {
            API: new API(new databaseApi(prepareDatabaseV1())),
            recaptchaToken: 'xxxxx', //update token!
        }*/
    }
    return {
        API: new API(new urlApi(location + "/api/v1")),
        recaptchaToken: 'xxxxx', //update token!
    }
}

export default getConfig(window.location.origin);